export default {
  id: null,
  nome: null,
  origemId: null,
  boardColumnId: null,
  urlRedirecionamento: null,
  urlConversao: null,
  ativo: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/campanharedesocialmodel.js